module.exports = __webpack_public_path__ + "assets/tw-49fb31d9c9a4dc1cb4a1e2291b9db916.svg";